<template>
  <div>
    <div class="path">
      <span class="normal pointer" @click="toEcology()">生态服务</span>
      <span class="normal space">/</span>
      <span class="normal pointer" @click="toList()">报工列表</span>
      <span class="normal space">/</span>
      <span class="active">报工编辑</span>
    </div>
    <div class="page">
      <div class="title">
        <h2>报工</h2>
        <div>
          <el-button size="small" @click="onSave()" :loading="loading">保存</el-button>
          <el-button type="primary" size="small" @click="onSave(true)" :loading="loading">保存并提交</el-button>
        </div>
      </div>
      <div>
        <h3>申请信息</h3>
        <el-form :model="dataForm" :rules="dataRule" ref="form" label-width="120px">
          <el-form-item class="w-half" label="项目名称：" prop="projectName">
            <div @click="onShowProject">
              <el-input readonly class="form-width" v-model="dataForm.projectName" placeholder="请选择">
                <div slot="suffix" class="searchIcon">
                  <i class="el-icon-search"></i>
                </div>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item class="w-half" label="申请单号：" prop="demandTableNo">
            <el-input readonly class="form-width" v-model="dataForm.demandTableNo"
              placeholder="不可编辑,通过项目带入"></el-input>
          </el-form-item>
          <el-form-item class="w-half" label="项目经理：" prop="projectManager">
            <el-input readonly class="form-width" v-model="dataForm.projectManager"
              placeholder="不可编辑,通过项目带入"></el-input>
          </el-form-item>
          <el-form-item class="w-half" label="装置名称：" prop="deviceName">
            <el-input readonly class="form-width" v-model="dataForm.deviceName" placeholder="不可编辑,通过项目带入"></el-input>
          </el-form-item>
          <el-form-item class="w-half" label="工作内容：" prop="workDescription">
            <el-input type="textarea" :rows="2" placeholder="请输入工作内容，2000字" v-model="dataForm.workDescription"
              :maxlength="2000" show-word-limit style="width: 882px">
            </el-input>
          </el-form-item>
          <el-form-item class="w-half" label="工作状态：" prop="workStatus">
            <el-button-group>
              <el-button :type="dataForm.workStatus === item.code ? 'primary' : ''" v-for="item in workStatusOptions"
                :key="item.code" @click="onSetWorkStatus(item)">{{ item.value }}</el-button>
            </el-button-group>
          </el-form-item>
          <el-form-item label="工时：" prop="deliveryNum">
            <el-input-number class="form-width" v-model="dataForm.deliveryNum" controls-position="right"
              placeholder="请输入，0.01-24" :max="24" :min="0.01"></el-input-number>
          </el-form-item>
          <el-form-item label="填报日期：">
            <el-date-picker class="form-width" v-model="dataForm.supplierOrderCreateTime" type="date" placeholder="选择年月"
              value-format="yyyy-MM-dd" format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <SelectProject ref="selectProject" @confirm="setProjectHandle"></SelectProject>
    </div>
  </div>
</template>

<script>
import SelectProject from "../component/reportSelectProject.vue";

export default {
  components: {
    SelectProject,
  },
  data() {
    return {
      loading: false,
      dataForm: {
        workStatus: "",
      },
      dataRule: {},
      id: "",
      workStatusOptions:
        window.SITE_CONFIG.dictList["OMS_SSO_WORK_STATUS"] || [],
    };
  },
  created() {
    this.id = this.$route.query.id;
    if (this.id) {
      this.getDataSource();
    }
  },
  methods: {
    onSetWorkStatus(res) {
      this.dataForm.workStatus = res.code;
    },
    setProjectHandle(res) {
      const { tableno, deviceid, devicename, projectmanage, projectname } = res;
      this.dataForm.demandTableNo = tableno;
      this.dataForm.deviceId = deviceid;
      this.dataForm.deviceName = devicename;
      this.dataForm.projectManager = projectmanage;
      // this.dataForm.projectName = projectname;
      this.$set(this.dataForm, "projectName", projectname);
    },
    onShowProject() {
      this.$refs.selectProject.onShow();
    },
    onSave(submit = false) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { proofFiles, ...other } = this.dataForm;
          const param = {
            ...other,
            // 是否直接提交
            submit,
          };

          if (this.id) {
            param.id = this.id;
          }
          this.loading = true;
          this.$http
            .post(
              `/front/oms/sso/supplier/order/addOrUpdateSupplierOrder`,
              param
            )
            .then(({ data: res }) => {
              const { code, data } = res;
              if (code === 0) {
                this.$message.success("提交成功");
                this.$router.push({
                  name: "ecologicalServices-report-detail",
                  query: {
                    id: data,
                  },
                });
              }
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          console.log("表单验证失败");
        }
      });
    },
    getDataSource() {
      this.$http
        .get(`/front/oms/sso/supplier/order/supplierOrderDetail/${this.id}`)
        .then(({ data: res }) => {
          const { code, data } = res;
          if (code === 0) {
            this.dataForm = data;
          }
        });
    },
    formatFileList(fileList) {
      return fileList.map((i) => {
        return {
          ossId: i.aliOssId,
          fileName: i.fileName,
          url: i.url,
        };
      });
    },
    toEcology() {
      this.$router.push({ name: "ecologicalServices" });
    },
    toList() {
      this.$router.push({ name: "ecologicalServices-report-list" });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  background: #fff;
  padding: 20px;
  min-height: 800px;

  ::v-deep .el-select {
    width: 300px;
  }
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

h2 {
  font-family: Alibaba PuHuiTi;
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
}

h3 {
  font-family: Alibaba PuHuiTi;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
}

.mr-20 {
  margin-right: 20px;
}

.el-button--primary {
  background-color: #2a54d1;
  border-color: #2a54d1;
}

.el-button--primary:hover {
  opacity: 0.9;
}

.flex {
  display: flex;
}

.fileTag {
  margin-bottom: 16px;
  color: #2a54d1;
  background-color: #f1f5fb;

  ::v-deep a {
    color: #2a54d1;
  }
}

.ml-80 {
  margin-left: 80px;
}

.w-half {
  width: calc(50% - 10px);
}

.form-width {
  width: 300px;
}

.searchIcon {
  color: #333;
  font-size: 16px;
  padding: 0 8px;
}
</style>
